import React, { useState } from 'react';

import { Image } from 'antd';

import defaultImage from '@src/theme/assets/images/default.png';

import { StyledHoverScaleImage } from './styles';

const HoverScaleImage = ({ source, width, height, alt = 'Image', preview = false, onClick }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <StyledHoverScaleImage width={width} height={height}>
      <Image
        src={source || defaultImage}
        width={width}
        height={height}
        placeholder={<img src={defaultImage} alt="loading" />}
        fallback={defaultImage}
        alt={alt}
        preview={preview && !hasError}
        onError={() => setHasError(true)}
        onClick={onClick}
      />
    </StyledHoverScaleImage>
  );
};

export default HoverScaleImage;
